import { convert } from 'html-to-text';

export const getTextFromHtmlString = (htmlString: string | null | undefined) =>
  convert(htmlString ?? '');
